module.exports = __webpack_public_path__ + "media/images/application/icons/icon-arrow-advert-ff2ba0d0241a6864d5682255fb1f4166.svg";